import { inject, InjectionKey, provide } from 'vue';

/**
 * どのレイアウトの中で描画されているかを表す
 * - `legacy`: 従来のレイアウト（main-view.vue）
 * - `next`: 新レイアウト（grid + リサイズ可能な左メニュー）
 */
export type LayoutVariant = 'legacy' | 'next';

const layoutVariantKey: InjectionKey<LayoutVariant> = Symbol('layoutVariant');

export const provideLayoutVariant = (variant: LayoutVariant): void => {
  provide(layoutVariantKey, variant);
};

export const useLayoutVariant = (): LayoutVariant =>
  inject(layoutVariantKey, 'legacy');

export const useIsNextLayout = (): boolean => useLayoutVariant() === 'next';
